@if (form!=null) {
  <form [formGroup]="form">
    <div class="form-row">
      <div class="form-group col-md-2">
        <label>CEP</label>
        <input class="mb-2 form-control" style="width: 103px;" type="text" formControlName="cep" (input)="buscaCEP($event.target.value)" placeholder="00000-000" mask="00000-000">
        @if (!this.form.get('cep').valid) {
          <div>
            @if (this.form.get('cep').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Endereço</label>
        <input class="mb-2 form-control" formControlName="endereco" type="text" placeholder="Endereço e número">
        @if (!this.form.get('endereco').valid) {
          <div>
            @if (this.form.get('endereco').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Complemento</label>
        <input class="mb-2 form-control" formControlName="compl" type="text" placeholder="">
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Bairro</label>
        <input class="mb-2 form-control" formControlName="bairro" type="text" placeholder="">
        @if (!this.form.get('bairro').valid) {
          <div>
            @if (this.form.get('bairro').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Estado</label>
        <select class="form-control" formControlName="uf" (change)="onChangeUF($event.target.value)">
          <option value="Selecione" disabled value=null>Estado</option>
          @for (est of estados; track est) {
            <option [value]="est.COD_UF">{{est.DCR_UF}}</option>
          }
        </select>
        @if (!this.form.get('uf').valid) {
          <div>
            @if (this.form.get('uf').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-md-3">
        <label>Cidade</label>
        <select class="form-control" formControlName="codCidade">
          <option value="Selecione" disabled value=null>Cidade</option>
          @for (cid of cidades; track cid) {
            <option [value]="cid.COD_CIDADE">{{cid.DCR_CIDADE}}</option>
          }
        </select>
        @if (!this.form.get('codCidade').valid) {
          <div>
            @if (this.form.get('codCidade').touched) {
              <div>
                <small class="text-danger">
                  Campo Obrigatório
                </small>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-row mt-5">
      <div class="input-group col-md-3">
        <input type="password" class="form-control" placeholder="Assinatura Eletrônica" formControlName="assinatura">
        <div class="input-group-append">
          <button class="btn btn-success" type="button" (click)="salvar()" [disabled]="!form.valid || loading">
            Salvar
            @if (loading) {
              <i class="fas fa-spinner fa-spin"></i>
            }
          </button>
        </div>
      </div>
    </div>
    @if (msgErro!=null) {
      <div class="msgErroForm">
        {{msgErro}}
      </div>
    }
  </form>
}